export default __webpack_public_path__ + "static/AccentLine-7d4433a4825690e5d3da957c3e699db2.svg";